import { HttpErrorResponse, HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { Router } from '@angular/router';
import { ToasterService } from '@services/toaster.service';
import { catchError, throwError } from 'rxjs';

export const errorHandlerInterceptor: HttpInterceptorFn = (req, next) => {
  const router = inject(Router);
  const toasterService = inject(ToasterService);
  return next(req).pipe(
    catchError((error: HttpErrorResponse) => {
      if (error.status === 401) {
        localStorage.clear();
        // modalService.close();
        // authService.setIsAuthenticated();
        toasterService.error(error.error?.message);
        router.navigate(['/auth']);
      } else if (error.status >= 500) {
        toasterService.error('Server error - Please report to Admin about this issue.');
      } else if (error.status === 404) {
        toasterService.error(error.status + ' - ' + (error.error.message || 'Not Found!'));
      } else if (error.status === 0) {
        toasterService.error('Unable to handle the request');
      } else {
        if (error.error?.message) {
          toasterService.error(error.error.message);
        }
      }
      return throwError(() => error);
    }),
  );
};
